
import React from 'react';
import Layout from '@/components/Layout/Layout';
import StandardCalculator from '@/components/Calculator/StandardCalculator';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const StandardCalculatorPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/calculators" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Calculators
          </Link>
          <h1 className="text-3xl font-bold mb-2">Standard Calculator</h1>
          <p className="text-gray-600 mb-6">
            Perform basic arithmetic calculations with this simple, easy-to-use calculator.
          </p>
        </div>
        
        <div className="mb-8">
          <StandardCalculator />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Standard Calculator</h2>
          <p>
            The standard calculator provides basic arithmetic operations including addition, 
            subtraction, multiplication, and division. It's perfect for everyday calculations
            and features a clean, intuitive interface.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Features</h3>
          <ul className="list-disc ml-6">
            <li>Basic arithmetic operations (add, subtract, multiply, divide)</li>
            <li>Clear and all-clear functions</li>
            <li>Responsive design that works on all devices</li>
            <li>History of recent calculations</li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default StandardCalculatorPage;
